import script from "./WoononSummaryProductsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononSummaryProductsTable.vue?vue&type=script&lang=ts&setup=true"

import "./WoononSummaryProductsTable.vue?vue&type=style&index=0&id=2bc91606&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc91606"]])

export default __exports__